import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import {
  CustomConfirmationPopupService,
  ConfirmationRequest,
} from './custom-confirmation-popup.service';

@Component({
  selector: 'app-custom-confirmation-popup',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './custom-confirmation-popup.component.html',
  styleUrl: './custom-confirmation-popup.component.scss',
})
export class CustomConfirmationPopupComponent implements OnInit, OnDestroy {
  show = false;
  currentConfig: ConfirmationRequest | null = null;

  private confirmationSubscription?: Subscription;

  constructor(private confirmationService: CustomConfirmationPopupService) {}

  ngOnInit(): void {
    this.confirmationSubscription = this.confirmationService.confirmation$.subscribe(
      (config) => {
        this.currentConfig = config;
        this.show = !!config;
      }
    );
  }

  ngOnDestroy(): void {
    if (this.confirmationSubscription) {
      this.confirmationSubscription.unsubscribe();
    }
  }

  onYes(): void {
    this.confirmationService.confirm();
  }

  onNo(): void {
    this.confirmationService.cancel();
  }
}
